import React, { useState, useEffect } from 'react';
import styles from 'components/switch/index.module.scss';

const Switch = ({ id, isChecked, onCheckChanged }) => {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const onChangeHandler = event => {
    onCheckChanged(event.target.checked);
  };

  return (
    <div className={styles.switch}>
      <label htmlFor={id}>
        <input id={id} value={id} checked={checked} type="checkbox" onChange={onChangeHandler} />
      </label>
    </div>
  );
};

export default Switch;
